
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/crafts/[activitySlug]",
      function () {
        return require("private-next-pages/crafts/[activitySlug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/crafts/[activitySlug]"])
      });
    }
  